import React from "react";

const NoProductFound = () => {
  return <p>No products found.</p>;
};

export default NoProductFound;
